import { ConductorOneChildActive, Router } from "@frui.ts/screens";
import { computed } from "mobx";
import { Modules } from "config";
import LocalizationService from "services/localizationService";
import BankTransferViewModel from "./bankTransferViewModel";
import CardGatewayViewModel from "./cardGatewayViewModel";
import PaygateReversalViewModel from "./paygateReversalViewModel";

const navigationName = "outgoing-payments";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [BankTransferViewModel, CardGatewayViewModel, PaygateReversalViewModel],
})
export default class OutgoingPaymentsViewModel extends ConductorOneChildActive<
  BankTransferViewModel | CardGatewayViewModel | PaygateReversalViewModel
> {
  constructor(
    private bankTransferViewModel: BankTransferViewModel,
    private cardGatewayViewModel: CardGatewayViewModel,
    private payGateReversalViewModel: PaygateReversalViewModel,
    private localizationService: LocalizationService
  ) {
    super();
    this.navigationName = navigationName;
    this.children.push(this.bankTransferViewModel);
    this.children.push(this.cardGatewayViewModel);
    this.children.push(this.payGateReversalViewModel);
  }

  protected onInitialize(): Promise<any> | void {
    this.tryActivateChild(this.children[0]);
    return super.onInitialize();
  }

  @computed
  get name() {
    return this.translate("name");
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.finance, `outgoingPayments.${code}`, size);
  }
}
